// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import { node, icon } from "~/util/dom";

export function pagination(index, len) {
	const cont = node("div", { className: "pagination" });
	const nextBtn = node("button", { className: "next", title: _("photo.pagination.next") });
	const prevBtn = node("button", { className: "prev", title: _("photo.pagination.prev") });

	nextBtn.setAttribute("data-log-ignore", "1");
	prevBtn.setAttribute("data-log-ignore", "1");

	cont.classList.add("first");
	cont.classList.add("last");

	nextBtn.appendChild(icon("forward"));
	prevBtn.appendChild(icon("back"));

	if (index != 0) {
		cont.appendChild(prevBtn);
		cont.classList.remove("first");
	}

	cont.appendChild(node("span", {}, `${index+1}/${len}`));

	if (index != len - 1) {
		cont.appendChild(nextBtn);
		cont.classList.remove("last");
	}

	return cont;
}
